module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/thurston_cover.b6f6f49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/thurston_cover.jpg
// module id = c23g
// module chunks = 1